import styled from '@emotion/styled';

const getBackgroundColor = ({ color }: { color: string }) => {
  switch (color) {
    case 'black':
      return 'black';
    case 'blue':
      return 'blue';
    case 'brown':
      return 'brown';
    case 'green':
      return 'green';
    case 'grey':
      return 'grey';
    case 'orange':
      return 'orange';
    case 'pink':
      return 'pink';
    case 'purple':
      return '#dda0dd';
    case 'red':
      return 'red';
    case 'white':
      return 'white';
    case 'yellow':
      return 'yellow';
    case 'beige':
      return 'beige';
    case 'dusty_blue':
      return '#889bae';
    case 'royal_blue':
      return '#4169e1';
    case 'navy':
      return 'navy';
    case 'burgundy':
      return '#800020';
    case 'lavender':
      return 'lavender';
    case 'plum':
      return '#843179';
    case 'rose':
      return '#ff0080';
    case 'dusty_rose':
      return '#dcae96';
    case 'coral':
      return 'coral';
    case 'peach':
      return '#ffe5b4';
    case 'emerald_green':
    case 'teal':
      return '#50c878';
    case 'gold':
      return 'gold';
    case 'silver':
      return 'silver';
    case 'rose_gold':
      return '#b76e79';
    case 'multi':
      return `radial-gradient(50% 50% at 50% 50%, #fff 0%, rgba(255, 255, 255, 0) 100%),
        conic-gradient(
          from -90deg at 50% 50%,
          #c0f -3.06deg,
          #f00 21.31deg,
          #f90 56.93deg,
          #ffe600 105.68deg,
          #fff500 141.31deg,
          #3f0 186.31deg,
          #0ff 236.94deg,
          #00f7ff 250.06deg,
          #000aff 293.19deg,
          #c0f 356.94deg,
          #f00 381.31deg
        )`;
    default:
      return '';
  }
};

export const ColorTag = styled.span<{ color: string }>`
  margin-right: 8px;
  border-radius: 50%;
  display: inline-block;
  height: 16px;
  width: 16px;
  background: ${getBackgroundColor};
  border: ${props =>
    props.color === 'white' ? `1px solid ${props.theme.COLORSV3.BLACK_100}` : 'initial'};
`;

export const ColorOption = styled.div`
  display: flex;
  align-items: center;
`;
